import React from 'react';
import PropTypes from 'prop-types';
import AlertLayout from '../../../components/layout/AlertLayout';

/**
 * DeleteConfirmation Component
 * A confirmation dialog for deleting share price records.
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Controls whether the dialog is open
 * @param {boolean} props.isLoading - Whether the deletion is in progress
 * @param {Function} props.onCancel - Callback when deletion is canceled
 * @param {Function} props.onConfirm - Callback when deletion is confirmed
 */
const DeleteConfirmation = ({ open, isLoading, onCancel, onConfirm }) => {
    return (
        <AlertLayout
            open={open}
            title="Are You Sure?"
            actionLoader={isLoading}
            closeAction={onCancel}
            positiveAction={{ label: 'Delete', onClick: onConfirm }}
        >
            <p className="fs-large-medium p-0 m-0">
                This action cannot be undone. This will permanently delete.
            </p>
        </AlertLayout>
    );
};
DeleteConfirmation.propTypes = {
    open: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default DeleteConfirmation;